<template>
  <v-main fluid class="pa-0 fill-height grey lighten-3">
    <div style="position:absolute;top:12px;left:12px;">
      <router-link to="/">
        <v-img :src="`${Utility.RES_SERVER}/static/img/logo.png`" width="180" contain></v-img>
      </router-link>
    </div>
    <v-row style="margin-top:35px;margin-bottom:60px;" justify="center">
      <v-col cols="4">
        <v-card tile style="opacity: 0.9;">
          <v-card-title>欢迎注册中科生信云平台</v-card-title>
          <v-card-subtitle v-if="errMsg" class="red--text">{{errMsg}}</v-card-subtitle>
          <v-card-text>
            <registry-form ref="registryForm" :registry-verify-code="registryVerifyCode" @error="onFormError"></registry-form>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters justify="center" align="center">
              <v-col cols="auto">
                <v-checkbox dense v-model="agreementFlag"></v-checkbox>
              </v-col>
              <v-col class="text-caption">
                <a class="text-decoration-none" :href="`${Utility.RES_SERVER}/policy.html`" target="_blank">《法律声明和隐私权政策》</a>
              </v-col>
            </v-row>
            <v-spacer />
            <v-btn @click="onRegistry" tile color="primary" v-one-click>提 交</v-btn>
            <v-btn color="primary" text to="/login">登录</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- <entry-footer></entry-footer> -->
    <v-footer dark absolute>
      <span>© 2004 - 2019 上海中科新生命生物科技有限公司 版权所有</span>
      <v-spacer></v-spacer>
      <div>沪ICP备14033860号</div>
    </v-footer>
  </v-main>
</template>
<script>
import RegistryForm from './RegistryForm.vue';
import { getApplicationValue, userRegistry } from '@/plugins/api';
import Vue from 'vue';
import $ from 'jquery';

export default {
  data () {
    return {
      errMsg: '',
      agreementFlag: false,
      registryVerifyCode: false
    }
  },
  components: { RegistryForm },
  created () {
    getApplicationValue().then(res => {
      this.registryVerifyCode = res.data && res.data.registryVerifyCode;
    })
  },
  methods: {
    onRegistry () {
      if (!this.agreementFlag) {
        this.errMsg = '请同意并勾选《法律声明和隐私权政策》';
        return;
      }
      let validRst = this.$refs.registryForm.validate();
      if (validRst !== true) {
        // this.errMsg = validRst;
        return;
      }
      let registryData = this.$refs.registryForm.getRegistryData();
      let registryFn = (mobileInfo) => {
        if (mobileInfo) registryData.province = mobileInfo.province;
        userRegistry(registryData).then(res => {
          if (res.status < 0) {
            this.errMsg = res.message;
            return;
          }
          Vue.ls.set('token', res.data.token);
          this.$store.commit('setToken', res.data.token);
          this.$router.push('/registry/success');
        })
      }
      this.getMobileCity(registryData.mobile, registryFn);
    },
    getMobileCity (mobile, callback) { // 获取手机号的注册城市
      $.ajax({
        type: 'get',
        timeout: 3000,
        url: 'https://tcc.taobao.com/cc/json/mobile_tel_segment.htm?tel=' + mobile,
        dataType: 'jsonp',
        jsonp: 'callback',
        success: (data) => callback(data),
        error: () => callback()
      })
    },
    onFormError (errMsg) {
      this.errMsg = errMsg;
    }
  }
}
</script>